import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';

const UnblockConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Modal.Header title={modalProps.title ?? t('unblock_confirmation')} subtitle={modalProps.subtitle} />
      <Modal.Footer
        confirmText={modalProps.confirmText ?? t('unblock')}
        confirmAction={modalProps.func}
        closeButtonText={modalProps.backText ?? t('annulla')}
      />
    </>
  );
};

export default UnblockConfirmationModal;
